import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { PiWarningCircleBold } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import { deleteLead, verifyOtp } from '../../../redux/actions/Files.action';
import logo from "assets/img/Sculpt-logo.png";

const DeleteModal = ({ deleteModal, deleteToggle, setChecked, leadId, limits, setLeadId, setMainPage, searchDefault1 }) => {

    const dispatch = useDispatch()
    const [otpData, setOtpData] = useState({ otp: '' })
    const [otpModal, setOtpModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [deleteId, setDeleteId] = useState()

    const handleOtpSend = () => {
        setOtpModal(!otpModal);
    }

    const otpToggle = () => {
        setLoader(true);
        setDeleteId(leadId)
        dispatch(verifyOtp({ patientIds: leadId })).then(() => {
            setLoader(false);
            deleteToggle(false);
            handleOtpSend()
        })
    };

    const handleOtp = (e) => {
        const { name, value } = e.target;
        setOtpData((prev) => ({
            ...prev, [name]: value
        }))
    }

    const handleDeleteProblam = () => {
        const payload = {
            patientIds: deleteId,
            otp: otpData.otp
        }
        dispatch(deleteLead(payload, limits, searchDefault1.status)).then(() => {
            setOtpData({ otp: '' })
            handleOtpSend()
            setLeadId([])
            setMainPage(1)
            setChecked(false)
        })
    }

    return (
        <>
            {loader && (
                <div className="loaderAdd">
                    <div className="loader_line"><img src={logo} className="w-[130px]" /></div>
                </div>
            )}
            <Modal show={deleteModal} onHide={deleteToggle} >
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className=''>
                    <Button variant="secondary" onClick={deleteToggle} className='px-4 bg-transparent border-[1px] text-black border-green-color'>
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={otpToggle}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* otp modal open in click yes */}

            <Modal show={otpModal} onHide={handleOtpSend}>
                <Modal.Body className="p-5">
                    <Form.Group className="mb-3" controlId="problem">
                        <Form.Label>OTP</Form.Label>
                        <Form.Control
                            type="text"
                            name="otp"
                            value={otpData.otp}
                            onChange={handleOtp}
                            placeholder="Enter OTP"
                            className="shadow-none focus:!border-theme-dark"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="">
                    <Button
                        variant="secondary"
                        onClick={handleOtpSend}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="!bg-theme-dark border-0 px-4"
                        onClick={handleDeleteProblam}
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};



export default DeleteModal;
